import { Configuration, ConfigurationParameters } from "./api";

const configParams: ConfigurationParameters = {
  basePath: "",
};

const config = (): Configuration => new Configuration({ ...configParams });

export default config;
